export class StyleCocheSeguro {
    public srcLogo:string = "https://storage.googleapis.com/inter-public-cloudstorage-prod/mobile/dev/img/INTERMX%20H-Bl.svg";
    public srcBanner:string = "url(../../assets/images/nuevobanner2.jpg)";
    public bgBanner:string = "#00142d";
    public bgServicios:string = "#0e1751";
    public bgPrimary:string = "#0e1751";
    public bgSecondary:string = "#009dd0";
    public bgTertiary:string = "#88DFF9";
    public bgFooter:string = "#009dd0";
    public colorBtn:string = "inter";
    public colorPicker:string = "#039ECC";
    public textMark:string = "#0e1751";
    public textMarkSecondary:string = '#00b8ff';
}